import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {Gallery} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/gallery.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {ProductImage} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_images.types';
import {ProductTileV2} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_tile_v2.types';
import {DEFAULT_PRODUCT_IMAGE_COLUMNS} from '@aboutyou/ui-components';
import {useProtoProductImageType} from '../../../shared-deprecated/useProductImageType';
import {createUrlWithPreselectedSize} from '../../ProductUrl';
import type {ProductTileEntities} from '../types';

const getGalleryForEntities = (gallery: Gallery): ProductImage[] => {
  const images: ProductImage[] = [];

  for (const element of gallery.elements) {
    if (element.type?.$case === 'image') {
      images.push(element.type.image.image);
    }
  }

  return images;
};

export const useTargetRouteState = ({
  tile,
  selectedCoupon,
  customSection,
  gridColumns,
}: {
  tile: ProductTileV2;
  selectedCoupon?: string;
  customSection?: string;
  gridColumns?: number;
}) => {
  const [pathname = '', search] = tile.link.url.split('?');
  const preferredProductImageType = useProtoProductImageType();

  const entityGallery = getGalleryForEntities(tile.gallery);

  const {pathname: targetRoutePathname, search: targetRouteSearch} =
    createUrlWithPreselectedSize({
      pathname,
      search,
      selectedCoupon,
    });

  const entities: ProductTileEntities = {
    badges: tile.badges,
    brand: {
      blackLogoImage: tile.adpSection?.brandLogo,
    } as Brand,
    product: {
      id: tile.productId,
      path: tile.link.url,
      shareUrl: '',
    } as Product,
    primaryBustImageGallery: entityGallery,
    primaryModelImageGallery: entityGallery,
    price: tile.price,
    preferredProductImageType:
      tile.adpSection?.productImageType ?? preferredProductImageType,
    selectedSizeId: tile.selectedSizeId,
    gallery: tile.gallery,
    gridColumns: gridColumns || DEFAULT_PRODUCT_IMAGE_COLUMNS,
  };

  const targetRouteState = {
    entities,
    customSection,
  };

  return {
    pathname: targetRoutePathname,
    search: targetRouteSearch,
    state: targetRouteState,
  };
};
